const urlPrefix = `/IlocosSur/Legislative/api`;
var vRecID;

const contactusMethod = (_url, _data) => {
    return new Promise(resolve => {
        var settings = {
            "url": `${urlPrefix}/leg-track/${_url}`,
            "method": "POST",
            "data": _data,
            "headers": {
                /* "Content-Type": "application/json" */
            }
        };
        $.ajax(settings)
            .always(function(msg) {
                resolve(msg);
            });
    });
}


$(() => {
    _showLoading();
    contactusMethod('get-contacts').then((data) => {
        if (data.success) {
            $("#sp-office-trunkline").html(data.spTrunkLine)
            $("#sp-office-trunkline").attr("href", "tel:" + data.spTrunkLine)

            $("#sp-local-no").html(data.spLocalNo)
            $("#sp-local-no").attr("href", "tel:" + data.spLocalNo)

            $("#office-vp").html(data.officeVP)
            $("#office-vp").attr("href", "tel:" + data.officeVP)

            $("#sp-sec").html(data.spSec)
            $("#sp-sec").attr("href", "tel:" + data.spSec)

            $("#email-add").html(data.email)
            $("#email-add").attr("href", "mailto:" + data.email)
        } else {
            _notif("error", data.message);
        }
        _hideLoading();
    });

    $("#submit_btn").on("click", function() {
        _showLoading();
        contactusMethod('add-msg', {
            "firstname": $("#firstname").val(),
            "lastname": $("#lastname").val(),
            "subject": $("#subject").val(),
            "email": $("#email").val(),
            "contact": $("#contact").val(),
            "body": $("#body").val()
        }).then((data) => {
            if (data.success) {
                $("#firstname").val('');
                $("#lastname").val('');
                $("#subject").val('');
                $("#email").val('');
                $("#contact").val('');
                $("#body").val('');

                _notif('success', data.message);
            } else {
                var message = [];
                $.each(data.message, function(key, value) {
                    message.push("<br>" + value);

                });
                console.log(message);
                _notif("error", message)
            }
        })
    })

});